import { Container } from "@remo-co/ui-core/src/components/Container";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import { Videocam } from "@remo-co/ui-core/src/icons/Videocam";
import { Mic } from "@remo-co/ui-core/src/icons/Mic";
import PrivateIcon from "./assets/Private.svg";
import { useStyles } from "./styles";

interface Props {
  isPrivate?: boolean;
}

const EventLabel = ({ isPrivate = false }: Props) => {
  const { t } = useI18n(["eventLanding"]);
  const styles = useStyles();

  return isPrivate ? (
    <Container flex justifyContent="flex-start">
      <Container flex alignItems="flex-start" right="xs" fullWidth={false}>
        <img src={PrivateIcon} alt="" />
      </Container>
      <Typography variant="h6">{t("private.event")}</Typography>
    </Container>
  ) : (
    <Container className={styles.micCamContainer}>
      <Container fullWidth>
        <Videocam /> <Mic />
      </Container>
      <Typography variant="body1" className={styles.eventDetailsInfoText}>
        {t("event.details.info")}
      </Typography>
    </Container>
  );
};

export default EventLabel;
